module.exports = __webpack_public_path__ + "media/invaderkilled.f625fdf3.ogg";